// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Depc","cell":"ColumnAccessor_cell__1Jm3k","firstCellAccent":"ColumnAccessor_firstCellAccent__2w2bW"};